import type { ShippingQuoteResponse } from 'services/shippingService';

const PREVIEW_KEY = 'subscriptionShippingPreview';
const PENDING_ADVANCE_KEY = 'subscriptionPendingAdvance';

export type SubscriptionShippingPreview = {
  planKey: string;
  cep: string;
  quote: ShippingQuoteResponse;
};

export type SubscriptionPendingAdvance = {
  planKey: string;
  quantity: number;
  subtotal: number;
  frete: number;
  total: number;
};

export const buildPlanKey = (plan: {
  label?: string;
  type?: string;
  price?: string;
} | null): string =>
  [plan?.label ?? '', plan?.type ?? '', plan?.price ?? ''].join('|');

export const formatCep = (digits: string): string =>
  digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;

export const saveSubscriptionShippingPreview = (
  preview: SubscriptionShippingPreview,
): void => {
  sessionStorage.setItem(PREVIEW_KEY, JSON.stringify(preview));
};

export const loadSubscriptionShippingPreview = (
  planKey: string,
): SubscriptionShippingPreview | null => {
  const raw = sessionStorage.getItem(PREVIEW_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as SubscriptionShippingPreview;
    return parsed.planKey === planKey ? parsed : null;
  } catch {
    return null;
  }
};

export const clearSubscriptionShippingPreview = (): void => {
  sessionStorage.removeItem(PREVIEW_KEY);
};

export const saveSubscriptionPendingAdvance = (
  pending: SubscriptionPendingAdvance,
): void => {
  sessionStorage.setItem(PENDING_ADVANCE_KEY, JSON.stringify(pending));
};

export const loadSubscriptionPendingAdvance = (
  planKey: string,
): SubscriptionPendingAdvance | null => {
  const raw = sessionStorage.getItem(PENDING_ADVANCE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as SubscriptionPendingAdvance;
    return parsed.planKey === planKey ? parsed : null;
  } catch {
    return null;
  }
};

export const clearSubscriptionPendingAdvance = (): void => {
  sessionStorage.removeItem(PENDING_ADVANCE_KEY);
};
